import { authClient, clearAccessToken, getAccessToken } from '@/lib/client';
import { ENDPOINT_ADMIN } from '@/utils/endpoints';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useEffect } from 'react';

export const Route = createFileRoute('/logout')({
  component: LogoutPage,
});

function LogoutPage() {
  const navigate = useNavigate();

  useEffect(() => {
    const handleLogout = async () => {
      try {
        const token = getAccessToken();
        if (token) {
          await authClient.post(
            ENDPOINT_ADMIN.googleLogout,
            {},
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );
        }
      } catch (error) {
        console.error('Logout API error:', error);
      } finally {
        clearAccessToken();
        navigate({ to: '/login', replace: true });
      }
    };

    handleLogout();
  }, [navigate]);

  return (
    <main className='flex min-h-screen items-center justify-center'>
      <p className='text-sm text-muted-foreground'>Signing you out&hellip;</p>
    </main>
  );
}
